import NivelPuestoService from 'src/modules/nivelPuesto/nivelPuestoService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'NIVELPUESTO_VIEW';

const nivelPuestoViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: nivelPuestoViewActions.FIND_STARTED,
      });

      const record = await NivelPuestoService.find(id);

      dispatch({
        type: nivelPuestoViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: nivelPuestoViewActions.FIND_ERROR,
      });

      getHistory().push('/nivel-puesto');
    }
  },
};

export default nivelPuestoViewActions;
